export default __webpack_public_path__ + "static/media/Tu_Billetera_Dark.05ffe783.svg";